<template>
    <div class="vehicle-reviews">
        <LoadingIndicator v-if="isLoading" />
        <div v-if="!isLoading && reviews.length === 0" class="vehicle-reviews__empty-state">
            <div class="vehicle-reviews__empty-state-text">
                {{ emptyReviewsText }}
            </div>
        </div>

        <Review v-for="review in displayedReviews" :key="review.id" :review="review" class="vehicle-reviews__review" />

        <button
            v-if="showMoreBtnVisible"
            class="button button--secondary-contrast button--small"
            @click="displayVehicleReviewsModal({ vehicle, reviews })"
        >
            {{ $t('pages.vehicle.reviews_show_more', { count: reviews.length }) }}
        </button>
    </div>
</template>

<script>
import Review from '~/components/Review.vue';
import LoadingIndicator from '~/components/LoadingIndicator';
import { ASSET_SUB_TYPE_CAMPERVAN, ASSET_SUB_TYPE_MOTORHOME, ASSET_SUB_TYPE_OTHER_CAMPER } from '~/config/assetTypes';
import modalMixin from '~/mixins/modalMixin';

export default {
    components: {
        LoadingIndicator,
        Review,
    },
    mixins: [modalMixin],
    props: {
        vehicle: {
            type: Object,
            default: () => {},
        },
        vehicleReviews: {
            type: Array,
            default: () => [],
        },
        displayAll: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            reviews: this.vehicleReviews,
            isLoading: false,
        };
    },
    computed: {
        showMoreBtnVisible() {
            return this.reviews.length > 2 && !this.displayAll;
        },
        displayedReviews() {
            if (this.showMoreBtnVisible) {
                return this.reviews.slice(0, 2);
            }

            return this.reviews;
        },
        isVehicleMotorhome() {
            return this.vehicle.subType === ASSET_SUB_TYPE_MOTORHOME;
        },
        isVehicleCampervan() {
            return this.vehicle.subType === ASSET_SUB_TYPE_CAMPERVAN;
        },
        isVehicleTypeOther() {
            return this.vehicle.subType === ASSET_SUB_TYPE_OTHER_CAMPER;
        },
        emptyReviewsText() {
            if (this.isVehicleMotorhome) {
                return this.$t('pages.vehicle.reviews_empty_motorhome');
            } else if (this.isVehicleCampervan) {
                return this.$t('pages.vehicle.reviews_empty_campervan');
            } else if (this.isVehicleTypeOther) {
                return this.$t('pages.vehicle.reviews_empty_other_camper');
            }

            return this.$t('pages.vehicle.reviews_empty_caravan');
        },
    },
    created() {
        if (this.reviews.length === 0) {
            this.getReviews();
        }
    },
    methods: {
        getReviews() {
            this.isLoading = true;

            this.$vehicleService
                .getReviews(this.vehicle.id)
                .then(reviews => {
                    this.reviews = reviews;
                    this.isLoading = false;
                })
                .catch(err => {
                    this.$sentry.captureException(err);
                });
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.vehicle-reviews {
    &__empty-state {
        text-align: center;
    }
    &__empty-state-text {
        display: block;
        @extend %heading-3;
    }

    &__review:not(:last-child) {
        margin-bottom: 24px;
    }
}
</style>
